import React from 'react';
import { motion } from 'framer-motion';
import { Download, Printer, MapPin, ShieldCheck } from 'lucide-react';
export function BrandClosing() {
  const features = [{
    icon: <Download className="w-6 h-6" data-id="element-7" />,
    text: 'Descarga inmediata'
  }, {
    icon: <Printer className="w-6 h-6" data-id="element-8" />,
    text: 'Listo para imprimir'
  }, {
    icon: <MapPin className="w-6 h-6" data-id="element-9" />,
    text: 'Adaptado a Argentina'
  }, {
    icon: <ShieldCheck className="w-6 h-6" data-id="element-10" />,
    text: 'Garantía de 7 días en todos los productos'
  }];
  return <section className="w-full bg-brand-bgAlt py-16 md:py-24 text-brand-text" data-id="element-11">
      <div className="max-w-4xl mx-auto px-6 md:px-8 text-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-13">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif leading-relaxed mb-8 text-black" data-id="element-14">
            Cada sistema de Intervención Digital fue creado pensando en el
            contexto real de trabajo clínico y educativo.
          </h2>

          <p className="text-xl md:text-2xl text-black/80 mb-16 leading-relaxed" data-id="element-15">
            No somos una tienda de recursos genéricos. Somos el sistema que te
            faltaba para trabajar como la profesional que ya sos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-16">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-center gap-4" data-id="element-17">
              <div className="w-12 h-12 rounded-full bg-brand-primary flex items-center justify-center text-white" data-id="element-18">
                {feature.icon}
              </div>
              <p className="font-medium text-sm md:text-base text-black" data-id="element-19">
                ✅ {feature.text}
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}